import { Input, Radio } from 'antd'
import React, { useEffect } from 'react'
import ModalStatusButtonGroup from '../../../components/apos/modal/ModalStatusButtonGroup'

const RoutineSelector = ({
  routineFrequency,
  routineType,
  selectedDaysOfWeek,
  dayOfMonth,
  onFrequencyChange,
  onTypeChange,
  onDaysOfWeekChange,
  onDayOfMonthChange,
  dayOfMonthError,
  disabled = false,
}) => {
  const daysOfWeek = [
    { label: '월', value: 'MONDAY' },
    { label: '화', value: 'TUESDAY' },
    { label: '수', value: 'WEDNESDAY' },
    { label: '목', value: 'THURSDAY' },
    { label: '금', value: 'FRIDAY' },
    { label: '토', value: 'SATURDAY' },
    { label: '일', value: 'SUNDAY' },
  ]

  const mapFrequencyToLabel = (frequency) => {
    switch (frequency) {
      case 'MONTHLY':
        return '매월'
      case 'WEEKLY':
        return '매주'
      case 'DAILY':
        return '매일'
      default:
        return ''
    }
  }

  const mapLabelToFrequency = (label) => {
    switch (label) {
      case '매월':
        return 'MONTHLY'
      case '매주':
        return 'WEEKLY'
      case '매일':
        return 'DAILY'
      default:
        return null
    }
  }

  const handleDayToggle = (dayValue) => {
    const isSelected = selectedDaysOfWeek.includes(dayValue)
    const newDays = isSelected
      ? selectedDaysOfWeek.filter((d) => d !== dayValue)
      : [...selectedDaysOfWeek, dayValue]
    onDaysOfWeekChange(newDays)
  }

  const handleDayOfMonthChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, '')
    onDayOfMonthChange(value === '' ? null : value)
  }

  // 주기 선택에 따라 라디오 버튼 자동 선택
  // disabled 상태일 때는 실행하지 않음 (이미 설정된 routineType 유지)
  useEffect(() => {
    if (disabled) return

    if (routineFrequency === 'MONTHLY') {
      // 매월 선택 시 일자로 선택
      onTypeChange('DAY_OF_MONTH')
    } else if (routineFrequency === 'WEEKLY') {
      // 매주 선택 시 요일로 선택
      onTypeChange('DAY_OF_WEEK')
    } else if (routineFrequency === 'DAILY') {
      // 매일 선택 시 null 처리
      onTypeChange(null)
      // onDaysOfWeekChange([])
      // onDayOfMonthChange('')
    }
  }, [routineFrequency, disabled])

  return (
    <div className="routine-schedule-wrapper">
      {/* 주기 선택 */}
      <div className="routine-frequency-group">
        <span className="routine-frequency-label">루틴 선택</span>
        <div className="status-button-wrapper">
          <ModalStatusButtonGroup
            options={['매월', '매주', '매일']}
            value={mapFrequencyToLabel(routineFrequency)}
            onChange={(label) => onFrequencyChange(mapLabelToFrequency(label))}
            disabled={disabled}
          />
        </div>
      </div>

      <div className="routine-selection-wrapper">
        {/* 선택 방식 라디오 버튼 */}
        <Radio.Group
          value={routineType}
          onChange={(e) => onTypeChange(e.target.value)}
          className="routine-type-radio"
          disabled={disabled}
        >
          <div className="routine-type-container">
            <div className="routine-radio-row">
              <Radio
                value="DAY_OF_WEEK"
                disabled={
                  disabled ||
                  routineFrequency === 'MONTHLY' ||
                  routineFrequency === 'DAILY' ||
                  !routineType
                }
              >
                요일로 선택
              </Radio>
              <div className="day-of-week-group">
                {daysOfWeek.map((day) => {
                  const isSelected = Array.isArray(selectedDaysOfWeek)
                    ? selectedDaysOfWeek.includes(day.value)
                    : false
                  return (
                    <button
                      key={day.value}
                      type="button"
                      className={`day-of-week-btn ${isSelected ? 'active' : ''}`}
                      onClick={() => handleDayToggle(day.value)}
                      disabled={
                        disabled ||
                        routineType !== 'DAY_OF_WEEK' ||
                        routineFrequency === 'MONTHLY' ||
                        routineFrequency === 'DAILY'
                      }
                    >
                      {day.label}
                    </button>
                  )
                })}
              </div>
            </div>

            <div className="routine-radio-row">
              <Radio
                value="DAY_OF_MONTH"
                disabled={
                  disabled ||
                  routineFrequency === 'WEEKLY' ||
                  routineFrequency === 'DAILY' ||
                  !routineType
                }
              >
                일자로 선택
              </Radio>
              <div
                className="day-of-month-group"
                style={{ position: 'relative' }}
              >
                <Input
                  placeholder="숫자로만 입력해주세요"
                  className="form-input"
                  value={dayOfMonth || ''}
                  onChange={handleDayOfMonthChange}
                  maxLength={2}
                  status={dayOfMonthError ? 'error' : ''}
                  disabled={
                    disabled ||
                    routineType !== 'DAY_OF_MONTH' ||
                    routineFrequency === 'WEEKLY' ||
                    routineFrequency === 'DAILY'
                  }
                />
                {dayOfMonthError && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      color: '#ff4d4f',
                      fontSize: '12px',
                      marginTop: '4px',
                    }}
                  >
                    {dayOfMonthError}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Radio.Group>
      </div>
    </div>
  )
}

export default RoutineSelector
